import { FC } from 'react';
import { useIntl } from 'react-intl';
import { DropdownMobileMenu } from '../DropdownMobileMenu/DropdownMobileMenu';
import { messages } from '../../i18n';

import { ApplicationsDropdownMenuMobileProps } from '../../defaultComponents/DefaultApplicationsDropdown/ApplicationsDropdownWrapper/ApplicationsDropdownWrapper.types';

export const ApplicationsDropdownMenuMobile: FC<ApplicationsDropdownMenuMobileProps> = ({ children, trigger, ...rest }) => {
  const { formatMessage } = useIntl();

  return <DropdownMobileMenu headerTitle={formatMessage(messages.appsMenuMobileHeader)} trigger={trigger} children={children} {...rest} />;
};
